import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";

const CardGraficos: React.FC<any> = (props) => {
  const [data, setData] = useState<any>({
    series: [
      {
        name: "series1",
        data: [10, 20, 30, 40, 50, 60, 70, 80, 90],
      },
    ],
    options: {
      chart: {
        height: 350,
        type: "area",
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
      },
      xaxis: {
        type: "numeric",
        categories: [1, 2, 3, 4, 5, 6, 7, 8, 9],
        decimalsInFloat: 0,
      },
      tooltip: {
        x: {
          format: "dd/MM/yy HH:mm",
        },
      },
    },
  });

  useEffect(() => {}, []);

  return (
    <div className="card border border-primary" style={{ height: "427px" }}>
      <div className="card-header bg-primary border border-primary py-1">
        <h6 className="card-title fw-bold text-white text-center m-0 py-2">
          Gráfico de animais ativos
        </h6>
      </div>
      <div className="card-body">
        <ReactApexChart
          options={data.options}
          series={data.series}
          type="area"
          height={350}
        />
      </div>
    </div>
  );
};

export default CardGraficos;
